var map = {
	"./de/btn-back.png": "TgZT",
	"./en/btn-back.png": "I0dG",
	"./es/btn-back.png": "iKFA",
	"./fr/btn-back.png": "YcCM",
	"./ja/btn-back.png": "A5Zw",
	"./ko/btn-back.png": "8c0z",
	"./pt/btn-back.png": "WO8L",
	"./ru/btn-back.png": "ijyl",
	"./tc/btn-back.png": "NqYP",
	"./th/btn-back.png": "7eBR",
	"./zh-Hant/btn-back.png": "u+sP"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fWe+";